import { Container, Row, Col, Badge, Button } from 'react-bootstrap';
import { motion } from 'motion/react';
import PricingComponent from '../components/home/Pricing';
import FAQs from '../components/home/FAQs';

const Pricing = () => {
  return (
    <>
      <section className="hero-section-primary section-xl text-white position-relative overflow-hidden">
        <Container className="position-relative">
          <Row className="align-items-center">
            <Col lg={10} className="mx-auto text-center">
              <motion.div
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ delay: 0.2 }}
              >
                <Badge bg="success" className="mb-3 fs-6">Flexible Pricing</Badge>
              </motion.div>
              <motion.h2 className="display-6 text-primary fw-bold mb-2"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.3 }}
              >
                Choose the Right Plan for Your Business
              </motion.h2>
              <motion.p className="lead mb-4 text-muted"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.4 }}
              >
                Explore our transparent pricing plans designed for businesses of all sizes. Get access to comprehensive civic services, business registration, licensing, and administrative solutions.
              </motion.p>
              <motion.div className="d-flex gap-3 justify-content-center flex-wrap"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.5 }}
              >
                <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
                  <Button variant="success" href="#pricing">View Pricing</Button>
                </motion.div>
                <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
                  <Button variant="outline-success" href="#">Contact Sales</Button>
                </motion.div>
              </motion.div>
            </Col>
          </Row>
        </Container>
      </section>
      <PricingComponent />
      <FAQs />
    </>
  )
}

export default Pricing;
